export default theme => ({
  '@global': {
    '.web5-sandboxCode__iframe': {
      display: 'none'
    }
  },
  root: {
    marginTop: -20,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    }
  },
  bulkText: {
    cursor: 'pointer'
  }
});